<template>
  <v-text-field
    id="moneyTextField"
    name="moneyTextField"
    ref="moneyTextField"
    :label="label"
    :append-icon="appendIcon"
    :prepend-icon="prependIcon"
    v-model.lazy="formattedValue"
    @input="input"
    @focus="focus"
    @click="focus"
    @change="change"
  ></v-text-field>
</template>
<script>
var utils = {
  assign(defaults, extras) {
    defaults = defaults || {};
    extras = extras || {};
    return Object.keys(defaults)
      .concat(Object.keys(extras))
      .reduce(function(acc, val) {
        acc[val] = extras[val] === undefined ? defaults[val] : extras[val];
        return acc;
      }, {});
  },

  format(input, opt) {
    if (typeof input === "number") {
      input = input.toFixed(this.fixed(opt.precision));
    }
    var negative = input.indexOf("-") >= 0 ? "-" : "";

    var numbers = this.onlyNumbers(input);
    var currency = this.numbersToCurrency(numbers, opt.precision);
    var parts = this.toStr(currency).split(".");
    var integer = parts[0];
    var decimal = parts[1];
    integer = this.addThousandSeparator(integer, opt.thousands);
    return (
      opt.prefix +
      negative +
      this.joinIntegerAndDecimal(integer, decimal, opt.decimal) +
      opt.suffix
    );
  },

  unformat(input, precision) {
    var negative = input.toString().indexOf("-") >= 0 ? -1 : 1;
    var numbers = this.onlyNumbers(input);
    var currency = this.numbersToCurrency(numbers, precision);
    return parseFloat(currency) * negative;
  },

  onlyNumbers(input) {
    return this.toStr(input).replace(/\D+/g, "") || "0";
  },

  // Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
  fixed(precision) {
    return this.between(0, precision, 20);
  },

  between(min, n, max) {
    return Math.max(min, Math.min(n, max));
  },

  numbersToCurrency(numbers, precision) {
    var exp = Math.pow(10, precision);
    var float = parseFloat(numbers) / exp;
    var currency = float.toFixed(this.fixed(precision));
    return currency;
  },

  addThousandSeparator(integer, separator) {
    return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
  },

  currencyToIntegerAndDecimal(float) {
    return this.toStr(float).split(".");
  },

  joinIntegerAndDecimal(integer, decimal, separator) {
    return decimal ? integer + separator + decimal : integer;
  },

  toStr(value) {
    return value ? value.toString() : "";
  },

  setCursor(el, position) {
    var setSelectionRange = function() {
      el.setSelectionRange(position, position);
    };
    if (el === document.activeElement) {
      setSelectionRange();
      setTimeout(setSelectionRange, 1); // Android Fix
    }
  },

  // https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events#The_old-fashioned_way
  event(name) {
    var evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
    return evt;
  }
};

var settings = {
  decimal: ",",
  thousands: ".",
  prefix: "R$ ",
  suffix: "",
  precision: 2
};

export default {
  name: "MoneyInput",
  props: ["value", "id", "name", "label", "prependIcon", "appendIcon"],
  data() {
    return {
      rawValue: 0,
      formattedValue: utils.format(this.value, settings),
      settings: {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 2
      }
    };
  },
  methods: {
    change(newVal) {
      this.formattedValue = utils.format(newVal, settings);
      this.rawValue = utils.unformat(newVal, settings.precision);

      var el = this.$refs.moneyTextField.$refs.input;
      var positionFromEnd =
        this.$refs.moneyTextField.value.length - el.selectionEnd;

      positionFromEnd = Math.max(positionFromEnd, this.settings.suffix.length); // right
      positionFromEnd = this.formattedValue.length - positionFromEnd;
      positionFromEnd = Math.max(
        positionFromEnd,
        this.settings.prefix.length + 1
      ); // left

      utils.setCursor(el, positionFromEnd);
    },
    focus(context) {
      var el = context.target;
      utils.setCursor(el, el.value.length - settings.suffix.length);
    },
    input(newVal) {
      var formattedValue = utils.format(newVal, settings);

      this.$nextTick(() => {
        this.change(formattedValue);
      });
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.rawValue = newVal;
        this.formattedValue = utils.format(this.rawValue, settings);
      },
      immediate: true
    },
    rawValue(newVal) {
      this.formattedValue = utils.format(newVal, settings);
      this.$emit("input", newVal);
    }
  },
  mounted() {
    //Use the settings from numeraljs
    var l = this.$numeral.locales[this.$numeral.options.currentLocale];
    settings.prefix = l.currency.symbol + " ";
    settings.decimal = l.delimiters.decimal;
    settings.thousands = l.delimiters.thousands;
  }
};
</script>
